<template>
  <CButton theme="ghost-secondary" v-tooltip="i18n.t(copied ? 'general.copied':'general.copy')"
           @click.prevent.stop="trigger" class="c-copy-button">
    <CIcon name="copy" :size="16"/>
  </CButton>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import CIcon from '@/shared/components/CIcon.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import { delay } from '@/shared/utils';
  import { elementRef } from '@/shared/utils/component';

  const i18n = useI18n();

  const content = elementRef();

  const props = defineProps<{
    text?: string,
  }>();

  const copied = ref(false);

  async function trigger() {
    const text = props.text || content.value?.textContent?.trim();
    if (text) {
      await navigator.clipboard.writeText(text);
      copied.value = true;
      await delay(1200);
      copied.value = false;
    }
  }
</script>

<style lang="scss">
  .c-copy-button.c-button-ghost {
    padding: .5rem;
    color: $neutral;
  }
</style>
